// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"587":"1e9c71c1","741":"b1fac16a"}[chunkId] + ".chunk.js";
};